export interface IDeviation {
    key: string;
    name: string;
}

interface ICardioDeviationsIndex {
    [key: string]: IDeviation[];
}

export interface ICardioDeviations extends ICardioDeviationsIndex {
    av_geleiding: IDeviation[];
    elektrische_hartas: IDeviation[];
    overig: IDeviation[];
    qrs_geleiding: IDeviation[];
    qrs_vorm: IDeviation[];
    ritme: IDeviation[];
    st_segment: IDeviation[];
}
export const cardioDeviations: ICardioDeviations = {
    av_geleiding: [
        { key: 'normale_geleiding', name: 'Normale geleiding' },
        { key: 'eerste_graads_av_blok', name: 'Eerste graads AV-blok' },
        { key: 'tweede_graads_av_blok_type_mobitz', name: 'Tweede graads AV-blok type Mobitz' },
        { key: 'tweede_graads_av_blok_typewenckebach', name: 'Tweede graads AV-blok type Wenckebach' },
        { key: 'totaal_av_blok', name: 'Totaal AV-blok' },
        { key: 'anders', name: 'anders, namelijk...' },
    ],
    elektrische_hartas: [
        { key: 'intermediair', name: 'Intermediair' },
        { key: 'linker_asdeviatie', name: 'Linkerasdeviatie' },
        { key: 'rechter_asdeviatie', name: 'Rechterasdeviatie' },
        { key: 'extreme_as', name: 'Extreme as' },
        { key: 'horizontale_hartas', name: 'Horizontale hartas' },
        { key: 'verticale_hartas', name: 'Verticale hartas' },
        { key: 'anders', name: 'Anders, namelijk...' },
    ],
    overig: [
        { key: 'linker_boezem_overbelasting', name: 'Linkerboezem overbelasting' },
        { key: 'rechter_boezem_overbelasting', name: 'Rechterboezem overbelasting' },
        { key: 'prominente_u_golf', name: 'Prominente U golf' },
        { key: 'anders', name: 'anders, namelijk...' },
    ],
    qrs_geleiding: [
        { key: 'qrs_normale_breedte', name: 'QRS normale breedte' },
        { key: 'fasciculus_anticus_blok', name: 'Fasciculus Anticus blok (LAHB)' },
        { key: 'fasciculus_posticus_blok', name: 'Fasciculus Posticus blok (LPHB)' },
        { key: 'compleet_rbtb', name: 'Compleet RBTB' },
        { key: 'incompleet_rbtb', name: 'Incompleet RBTB' },
        { key: 'compleet_lbtb', name: 'Compleet LBTB' },
        { key: 'incompleet_lbtb', name: 'Incompleet LBTB' },
        { key: 'aspecifieke_iv_geleidingsvertraging', name: 'Aspecifieke IV geleidingsvertraging' },
        { key: 'anders', name: 'anders, namelijk...' },
    ],
    qrs_vorm: [
        { key: 'normaal_voltage', name: 'Normaal voltage' },
        { key: 'laag_voltage_in_standaard_afleidingen', name: 'Laag voltage in standaard afleidingen' },
        { key: 'tekenen_van_lvh', name: 'Tekenen van LVH' },
        { key: 'tekenen_van_rvh', name: 'Tekenen van RVH' },
        { key: 'pre_exitatie', name: 'Pre-exitatie' },
        { key: 'trage_r_top_progressie_over_voorwand', name: 'Trage R-top progressie over voorwand' },
        { key: 'voorwand_infarct', name: 'Voorwand infarct (doorgemaakt)' },
        { key: 'onderwand_infarct', name: 'Onderwand infarct (doorgemaakt)' },
        { key: 'hoog_lateraal_infarct', name: 'Hooglateraal infarct (doorgemaakt)' },
        { key: 'inferolateraal_infarct', name: 'Inferolateraal infarct (doorgemaakt)' },
        { key: 'achterwand_infarct', name: 'Achterwand infarct (doorgemaakt)' },
        { key: 'anders', name: 'Anders, namelijk...' },
    ],
    ritme: [
        { key: 'sinusritme', name: 'Sinusritme' },
        { key: 'atriumfibrilleren', name: 'Atriumfibrilleren' },
        { key: 'atriumflutter', name: 'Atriumflutter' },
        { key: 'sinusaritmie', name: 'Sinusaritmie' },
        { key: 'sa_block', name: 'SA-blok' },
        { key: 'sinus_arrest', name: 'Sinusarrest' },
        { key: 'ectopisch_boezemritme', name: 'Ectopisch boezemritme' },
        { key: 'atriale_tachycardie', name: 'Atriale tachycardie' },
        { key: 'sinustachycardie', name: 'Sinustachycardie' },
        { key: 'ventriculaire_tachycardie_sustained', name: 'Ventriculaire tachycardie sustained' },
        { key: 'ventriculaire_tachycardie_non_sustained', name: 'Ventriculaire tachycardie non-sustained' },
        { key: 'torsades_des_pointes', name: 'Torsades des pointes' },
        { key: 'supraventriculair_ritmestoornis', name: 'Supraventriculair ritmestoornis' },
        { key: 'av_nodaal_ritme', name: 'AV-nodaal ritme' },
        { key: 'avnrt', name: 'AVNRT' },
        { key: 'geblokkeerde_pac_bij_av_geleiding', name: 'Geblokkeerde PAC bij AV geleiding' },
        { key: 'prematuur_atriaal_complex', name: 'Prematuur atriaal complex' },
        { key: 'prematuur_ventriculair_complex', name: 'Prematuur ventriculair complex' },
        { key: 'fusie_complex', name: 'Fusiecomplex' },
        { key: 'ventriculair_pacemakerritme', name: 'Ventriculair pacemakerritme' },
        { key: 'ddd_pacemakerritme', name: 'DDD pacemakerritme' },
        { key: 'atriaal_pacemakerritme', name: 'Atriaal pacemakerritme' },
        { key: 'ventriculair_escaperitme', name: 'Ventriculair escaperitme' },
        { key: 'niet_te_bepalen_ritme', name: 'Niet te bepalen ritme' },
        { key: 'anders', name: 'Anders, namelijk...' },
    ],
    st_segment: [
        { key: 'geen_ischemie', name: 'Geen ischemie' },
        { key: 'secundaire_repolarisatie_stoornissen', name: 'Secundaire repolarisatiestoornissen' },
        { key: 'aspecifieke_repolarisatiestoornissen', name: 'Aspecifieke repolarisatiestoornissen' },
        { key: 'wel_ischemie', name: 'Wel ischemie, te weten...' },
    ],
};
